import { FirebaseDocRefType } from 'firebase/index'
import { CheckoutStatusType } from 'types/checkout'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { fetchOrdersAction, setCheckoutUnsubscribesAction } from 'reducks/checkout/actions'
import { hideLoadingAction } from 'reducks/loading/actions'
import { CheckoutItemType } from 'types/checkoutItem'
import {
  fetchBreadRefsByManufacturerRef,
  fetchCheckoutItemsByRef,
  mergeListeningCheckoutWithItems,
} from 'reducks/checkout/operations'

const fetchDailyOrders = (date: string, storeRef: FirebaseDocRefType, status: CheckoutStatusType[]) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // unsubscribeがセットされている状態（リスナーがONの状態）であれば処理しない
    if (getState().checkout.is_set_unsubscribe) return

    const manufacturerRef: FirebaseDocRefType = getState().auth.manufacturer_ref
    let breadRefs: FirebaseDocRefType[] = []
    const isSacriStationMode = typeof manufacturerRef !== 'undefined'

    // 販売元店舗がsacri stationを表示する場合、自店舗の決済のみに絞り込む
    if (isSacriStationMode) {
      breadRefs = await fetchBreadRefsByManufacturerRef(storeRef, manufacturerRef)

      // sacri stationに出品していない場合
      if (breadRefs.length === 0) {
        dispatch(fetchOrdersAction([]))
        dispatch(hideLoadingAction())
        return
      }
    }

    const unsubscribe = await storeRef
      .collection('store_checkouts')
      .where('status', 'in', status)
      .where('date', '==', date)
      .where('type', '==', 'daily')
      .onSnapshot(async (snapshots) => {
        const itemPromises: Promise<CheckoutItemType[]>[] = []
        // データの追加のみ監視する
        const changes = snapshots.docChanges().filter((change) => change.type === 'added')
        changes.forEach((change) => {
          itemPromises.push(fetchCheckoutItemsByRef(change.doc.ref, breadRefs))
        })
        const result = await Promise.all(itemPromises).catch((error) => {
          throw new Error(`注文商品の一括取得に失敗: ${error}`)
        })
        const items = result.reduce((prev, _items) => [...prev, ..._items], [])
        const currentOrders = getState().checkout.orders
        mergeListeningCheckoutWithItems(changes, items, currentOrders, dispatch, 'created_at', 'desc')
      })

    dispatch(setCheckoutUnsubscribesAction([unsubscribe]))
  }
}

export default fetchDailyOrders
